// extracted by mini-css-extract-plugin
export default {"FeatureImage":"FeaturesTab_FeatureImage__KDf6d","TabButton":"FeaturesTab_TabButton__IN+yc"};